export const KVmH = 'кВт⋅ч'
export const HEAT = 'Гкал'
export const KILLO = 1000
